import { cn } from '@/lib/utils';

import { useFormTopbarStore } from './form-topbar-store';

export function FormTopbar({ className }: { className?: string }) {
  const { info, actions } = useFormTopbarStore();
  return (
    <div className={cn('border-grey-3 relative flex min-h-[55px] w-full justify-between border-b-2 px-4 pt-2', className)}>
      <div>{info}</div>
      <div>{actions}</div>
    </div>
  );
}
